module.exports = __webpack_public_path__ + "img/img4.14ab7f0f.png";